module.exports = __webpack_public_path__ + "static/dra-filomena-montemurro-logos-07f62c18b2caf3c720a577bb55bad54d.svg";